export enum NotificationType {
    SUCCESS = 0,
    ERROR = 1,
}
